




















































































































import { Component, Vue, Prop } from 'vue-property-decorator';

import { Utils, DataBus, TireStoringContract, TireStoringInfo, ResponseCodeEnum, TireTypeEnum, ContractPeriodEnum } from '@/models';
import { toastService, imageService } from '@/services';

@Component
export default class TireRegisterInputImage extends Vue {
  @Prop() public isEdit!: boolean;
  @Prop() public tireContract!: TireStoringContract;
  @Prop() public tireContractList!: TireStoringContract[];

  private showTabSummer: boolean = true;
  private showTabWinter: boolean = true;
  private currentTirePaint!: TireStoringInfo;
  private activeTabSummer: boolean | null = null;
  private activeTabWinter: boolean | null = null;

  private created() {
    if (this.tireContract.period === ContractPeriodEnum.SIX_MONTH) {
      this.showTabSummer = this.tireContract.tireType === TireTypeEnum.SUMMER;
      this.showTabWinter = this.tireContract.tireType === TireTypeEnum.WINTER;
    } else {
      this.showTabSummer = true;
      this.showTabWinter = true;
    }
    if (this.tireContract.tireType === TireTypeEnum.SUMMER) {
      this.activeTabSummer = true;
    } else {
      this.activeTabWinter = true;
    }
  }

  private chooseImage(event: any, tire: any) {
    // tire.imageUrl = URL.createObjectURL(file);
    const file = event.target.files[0];
    Utils.getRotatedImage(file)
      .then((res) => tire.imageUrl = URL.createObjectURL(res));
  }

  private save(): Promise<any> {
    return new Promise((resolve, reject) => {
      const summerTires: TireStoringInfo[] = this.tireContract.summerSeasonInfo ? this.tireContract.summerSeasonInfo.tires : [];
      const summerExistImages: any[] = summerTires
        .map((t1, index) => {
          return {
            fileIndex: index,
            file: t1.file,
          };
        })
        .filter((t2) => t2.file !== undefined);
      const summerImageFiles: File[] = summerExistImages.map((img) => img.file);

      const winterTires: TireStoringInfo[] = this.tireContract.winterSeasonInfo ? this.tireContract.winterSeasonInfo.tires : [];
      const winterExistImages: any[] = winterTires
        .map((t1, index) => {
          return {
            fileIndex: index,
            file: t1.file,
          };
        })
        .filter((t2) => t2.file !== undefined);
      const winterImageFiles: File[] = winterExistImages.map((img) => img.file);

      // Upload images
      imageService.saveTireImage(summerImageFiles, winterImageFiles)
        .then((res) => {
          if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
            if (res.data.data.summerTireImages) {
              res.data.data.summerTireImages.forEach((image, index) => {
                const fileIndex = summerExistImages[index].fileIndex;
                if (this.tireContract.summerSeasonInfo
                  && this.tireContract.summerSeasonInfo.tires
                  && this.tireContract.summerSeasonInfo.tires[fileIndex]) {
                  this.tireContract.summerSeasonInfo.tires[fileIndex].imageId = image.id;
                }
              });
            }
            if (res.data.data.winterTireImages) {
              res.data.data.winterTireImages.forEach((image, index) => {
                const fileIndex = winterExistImages[index].fileIndex;
                if (this.tireContract.winterSeasonInfo
                  && this.tireContract.winterSeasonInfo.tires
                  && this.tireContract.winterSeasonInfo.tires[fileIndex]) {
                  this.tireContract.winterSeasonInfo.tires[fileIndex].imageId = image.id;
                }
              });
            }
            resolve();
            return;
          } 

          reject();     
          return;
        });
    })
  }

  private saveAndGoBack() {
    this.save().then(() => {
      this.$emit('loadComponent', new DataBus({
        event: 'confirm_info',
      }));
    });
  }

  private cancelRegister() {
    if (!this.isEdit) {
      this.$emit('loadComponent', new DataBus({
        event: 'cancel_register',
      }));
    }
  }

  private goToImageEdit() {
    this.save().then(() => {
      this.$emit('loadComponent', new DataBus({
        event: 'image_edit',
      }));
    });
  }

}
